import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./componenets/ProtectedRoute";
import Home from "./pages/student/home/Home";
import Landing from "./pages/landing/Landing";
import PCAnnouncements from "./pages/projectcoordinator/announcements/Announcements";
import TAHome from "./pages/thrustarea/home/TAHome";
import TAReport from "./pages/thrustarea/report/Report";
import TAAnnouncements from "./pages/thrustarea/announcements/TAAnnouncements";
import TAListedprojects from "./pages/thrustarea/listedprojects/TAListedprojects";
import TAProjectDetails from "./pages/thrustarea/listedprojects/TAProjectDetails";
import { ComponentProvider } from "./context/ComponentContext";
import FloatingNavbar from "./componenets/floatingnavbar/FloatingNavbar";
import Footer from "./componenets/footer/Footer";
import DownloadsContainer from "./containers/student/downloads/DownloadsContainer";
import ProgressContainer from "./containers/student/progress/ProgressContainer";
import AddProjectContainer from "./containers/student/addproject/AddProjectContainer";
import GuidesContainer from "./containers/student/guides/GuidesContainer";
import GuideHome from "./pages/guide/home/GuideHome";
import PCHomeContainer from "./containers/projectcoordinator/home/PCHomeContainer";
import Listedprojectscontainer from "./containers/projectcoordinator/listedprojects/Listedprojectscontainer";
import ProjectDetailsContainer from "./containers/projectcoordinator/projectdetails/ProjectDetailsContainer";
import AnnouncementsContainer from "./containers/admin/announcements/AnnouncementsContainer";
import AdminHomeContainer from "./containers/admin/home/AdminHomeContainer";
import GroupsContainer from "./containers/admin/groups/GroupsContainer";
import Students from "./containers/admin/groups/students/Students";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Faculty from "./containers/admin/groups/faculty/Faculty";
import Guide from "./containers/admin/groups/guide/Guide";
import ProjectCoordinator from "./containers/admin/groups/projectcoordinator/ProjectCoordinator";
import ThrustAreaCoordinator from "./containers/admin/groups/thrustareacoordinator/ThrustAreaCoordinator";
import Examiner from "./containers/admin/groups/examiner/Examiner";
import PCReportContainer from "./containers/projectcoordinator/report/ReportContainer";
import AdminReportContainer from "./containers/admin/report/ReportContainer";
import DefaulterList from "./containers/admin/defaulter/DefaulterList";
import ExaminerHomeContainer from "./containers/examiner/home/ExaminerHomeContainer";
import { AuthProvider } from "./context/AuthContext";
import GuideProgressContainer from "./containers/guide/progress/GuideProgressContainer";
import AddExpertContainer from "./containers/guide/expert/AddExpertContainer";
import ExpertsContainer from "./containers/student/expert/ExpertsContainer";
import Team from "./containers/student/team/Team";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
    return (
        <GoogleOAuthProvider clientId="738251301050-umbjfl4oqt0h4js9v5crdjljcos07nbq.apps.googleusercontent.com">
            <AuthProvider>
                <ComponentProvider>
                    <ToastContainer position="top-right" autoClose={3000} />
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={<Landing />} />

                            {/* Student Routes */}
                            <Route
                                path="/student/home"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["student", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <Home />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/student/experts"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["student", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <ExpertsContainer />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/student/guides"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["student", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <GuidesContainer />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/student/addproject"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["student", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <AddProjectContainer />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/student/team"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["student", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <Team />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/student/progress"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["student", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <ProgressContainer />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/student/downloads"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["student", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <DownloadsContainer />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            {/*Guide Routes */}
                            <Route
                                path="/guide/home"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["guide", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <GuideHome />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/guide/progress"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["guide", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <GuideProgressContainer />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/guide/downloads"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["guide", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <DownloadsContainer />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/guide/team"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["guide", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <Team />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />



                            {/*Examiner Routes */}

                            <Route
                                path="/examiner/home"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["examiner", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <ExaminerHomeContainer />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/examiner/team"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["examiner", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <Team />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/examiner/evaluation"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["guide", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <ProgressContainer />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/examiner/downloads"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["examiner", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <DownloadsContainer />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            {/* Project Coordinator Routes */}
                            <Route
                                path="/pc/home"
                                element={
                                    <ProtectedRoute allowedRoles={["pc", "sa"]}>
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <PCHomeContainer />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/pc/project"
                                element={
                                    <ProtectedRoute allowedRoles={["pc", "sa"]}>
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <Listedprojectscontainer />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/pc/project/:projectId"
                                element={
                                    <ProtectedRoute allowedRoles={["pc", "sa"]}>
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <ProjectDetailsContainer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/pc/announcements"
                                element={
                                    <ProtectedRoute allowedRoles={["pc", "sa"]}>
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <PCAnnouncements />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/pc/expert"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["pc", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <AddExpertContainer />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/pc/report"
                                element={
                                    <ProtectedRoute allowedRoles={["pc", "sa"]}>
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <PCReportContainer />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/pc/team"
                                element={
                                    <ProtectedRoute allowedRoles={["pc", "sa"]}>
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <Team />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            {/* Admin Routes */}
                            <Route
                                path="/admin/home"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["admin", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <AdminHomeContainer />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin/groups"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["admin", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <GroupsContainer />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/admin/groups/students"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["admin", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <Students />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin/groups/faculty"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["admin", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <Faculty />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin/groups/guide"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["admin", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <Guide />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin/groups/thrustareacoordinator"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["admin", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <ThrustAreaCoordinator />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin/groups/projectcoordinator"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["admin", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <ProjectCoordinator />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin/groups/examiner"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["admin", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <Examiner />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/admin/report"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["admin", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <AdminReportContainer />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/admin/announcements"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["admin", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <AnnouncementsContainer />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin/team"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={["admin", "sa"]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <Team />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/admin/defaulter-list"
                                element={
                                    <ProtectedRoute allowedRoles={["admin", "sa"]}>
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <DefaulterList />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            {/* Thrust Area Routes */}
                            <Route
                                path="/thrustarea/home"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={[
                                            "ta",
                                            "thrustarea",
                                            "sa",
                                        ]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <TAHome />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/thrustarea/project"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={[
                                            "ta",
                                            "thrustarea",
                                            "sa",
                                        ]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <TAListedprojects />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/project/:id"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={[
                                            "ta",
                                            "thrustarea",
                                            "sa",
                                            "pc",
                                            "guide",
                                            "student",
                                            "examiner",
                                            "admin"
                                        ]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <TAProjectDetails />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/thrustarea/announcements"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={[
                                            "ta",
                                            "sa",
                                            "thrustarea",
                                        ]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <TAAnnouncements />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/thrustarea/report"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={[
                                            "ta",
                                            "sa",
                                            "thrustarea",
                                        ]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <TAReport />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/thrustarea/team"
                                element={
                                    <ProtectedRoute
                                        allowedRoles={[
                                            "ta",
                                            "sa",
                                            "thrustarea",
                                        ]}
                                    >
                                        <div className="App pt-[70px] md:pt-[90px]">
                                            <FloatingNavbar />
                                            <Team />
                                            <Footer />
                                        </div>
                                    </ProtectedRoute>
                                }
                            />
                        </Routes>
                    </BrowserRouter>
                </ComponentProvider>
            </AuthProvider>
        </GoogleOAuthProvider>
    );
}

export default App;
